/* Runnsun — comportamento da loja.
   Tudo aqui é progressivo: sem JS a loja continua navegável, porque os filtros,
   a busca e o carrinho são formulários de verdade. */
(function () {
  'use strict';

  const cfg = window.Runnsun || {};
  const brl = centavos =>
    (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const $  = (s, raiz = document) => raiz.querySelector(s);
  const $$ = (s, raiz = document) => [...raiz.querySelectorAll(s)];

  /* ---------------------------------------------------------- gaveta do menu */
  (function menu() {
    const gaveta = $('#gaveta');
    const fundo = $('#fundo-gaveta');
    const abrir = $('#abrir-menu');
    if (!gaveta || !fundo || !abrir) return;

    const mostra = v => {
      gaveta.dataset.aberta = v;
      fundo.dataset.aberta = v;
      abrir.setAttribute('aria-expanded', v);
      document.body.style.overflow = v === 'true' ? 'hidden' : '';
    };
    abrir.addEventListener('click', () => mostra('true'));
    $('#fechar-menu')?.addEventListener('click', () => mostra('false'));
    fundo.addEventListener('click', () => mostra('false'));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') mostra('false'); });
  })();

  /* ------------------------------------------------------- carrossel do banner */
  (function banner() {
    const trilho = $('#trilho');
    if (!trilho || trilho.children.length < 2) return;

    const slides = [...trilho.children];
    const pontos = $('#pontos');
    let atual = 0, parado = false;

    slides.forEach((_, i) => {
      const b = document.createElement('button');
      b.className = 'banner__ponto';
      b.type = 'button';
      b.setAttribute('aria-label', `Ir para o slide ${i + 1}`);
      b.addEventListener('click', () => vaiPara(i));
      pontos?.appendChild(b);
    });

    const marca = () => [...(pontos?.children || [])]
      .forEach((p, i) => p.setAttribute('aria-current', i === atual ? 'true' : 'false'));

    function vaiPara(i) {
      atual = (i + slides.length) % slides.length;
      trilho.scrollTo({ left: trilho.clientWidth * atual, behavior: 'smooth' });
      marca();
    }

    $('#slide-anterior')?.addEventListener('click', () => vaiPara(atual - 1));
    $('#slide-proximo')?.addEventListener('click', () => vaiPara(atual + 1));

    let t;
    trilho.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const i = Math.round(trilho.scrollLeft / trilho.clientWidth);
        if (i !== atual) { atual = i; marca(); }
      }, 120);
    });

    const secao = trilho.closest('.banner');
    ['mouseenter', 'focusin'].forEach(e => secao.addEventListener(e, () => parado = true));
    ['mouseleave', 'focusout'].forEach(e => secao.addEventListener(e, () => parado = false));

    const reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduzido) setInterval(() => { if (!parado) vaiPara(atual + 1); }, 6000);
    marca();
  })();

  /* --------------------------------------------- galerias de evento (várias) */
  $$('[data-galeria]').forEach(g => {
    const trilho = $('.galeria-slide__trilho', g);
    const pontos = $('.galeria-slide__pontos', g);
    const total = trilho?.children.length || 0;
    if (total < 2) {
      $$('.galeria-slide__seta', g).forEach(s => s.hidden = true);
      return;
    }
    let atual = 0;

    for (let i = 0; i < total; i++) {
      const b = document.createElement('button');
      b.className = 'galeria-slide__ponto';
      b.type = 'button';
      b.setAttribute('aria-label', `Ir para a foto ${i + 1}`);
      b.addEventListener('click', () => vaiPara(i));
      pontos.appendChild(b);
    }
    const marca = () => [...pontos.children]
      .forEach((p, i) => p.setAttribute('aria-current', i === atual ? 'true' : 'false'));
    function vaiPara(i) {
      atual = (i + total) % total;
      trilho.scrollTo({ left: trilho.clientWidth * atual, behavior: 'smooth' });
      marca();
    }
    $$('[data-ir]', g).forEach(b =>
      b.addEventListener('click', () => vaiPara(atual + Number(b.dataset.ir))));
    marca();
  });

  /* ------------------------------------------------------- filtros da categoria */
  (function filtros() {
    const painel = $('#filtros');
    const abrir = $('#abrir-filtros');
    if (!painel || !abrir) return;

    const topo = $('#topo-filtros');
    const mostra = v => {
      painel.dataset.aberto = v;
      if (topo) topo.hidden = v !== 'true';
      document.body.style.overflow = v === 'true' ? 'hidden' : '';
    };
    abrir.addEventListener('click', () => mostra('true'));
    $('#fechar-filtros')?.addEventListener('click', () => mostra('false'));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') mostra('false'); });

    // marcar um filtro já aplica: o botão "Aplicar" só existe sem JS
    const form = $('#form-filtros');
    form?.addEventListener('change', () => form.submit());
    $('#ordem')?.addEventListener('change', () => form?.submit());
  })();

  /* ---------------------------------------------------------- página de produto */
  (function produto() {
    const seletor = $('#variante-escolhida');
    if (!seletor) return;

    /* Lê as variantes uma vez. O <select> escondido é a fonte: ele já traz
       preço, estoque, disponibilidade e a foto de cada combinação. */
    const variantes = [...seletor.options].map(o => ({
      el: o,
      valor: o.value,
      opcoes: o.dataset.opcoes.split('|'),
      disponivel: !o.disabled,
      fotoPos: Number(o.dataset.fotoPos || 0)
    }));

    const escolhido = [...seletor.options].find(o => o.selected);
    let atual = escolhido ? escolhido.dataset.opcoes.split('|') : [];
    let fotoAtual = escolhido ? Number(escolhido.dataset.fotoPos || 0) : 0;

    /* Mesma regra do Liquid: um valor respeita as opções ANTERIORES.
       Cor (1ª) nunca trava; Tamanho (2ª) mostra o estoque daquela cor. */
    const casaAnteriores = (v, ate) =>
      atual.slice(0, ate).every((sel, j) => v.opcoes[j] === sel);

    function marcaDisponiveis() {
      $$('[data-opcao]').forEach(botao => {
        const i = Number(botao.dataset.opcao);
        const valor = botao.dataset.valor;
        const ok = variantes.some(v =>
          v.disponivel && v.opcoes[i] === valor && casaAnteriores(v, i));
        /* A primeira opção (cor) nunca trava: esgotada, fica só marcada, para
           o cliente poder abrir as fotos dela. As seguintes (tamanho) travam,
           porque aí não há mais nada a ver — é o mesmo tênis. */
        if (i === 0) {
          botao.classList.toggle('numero--esgotado', !ok);
        } else {
          botao.disabled = !ok;
        }
        if (ok) botao.removeAttribute('aria-label');
        else botao.setAttribute('aria-label', `${valor} — sem estoque`);
      });
    }

    function marcaEscolhidos() {
      atual.forEach((valor, i) => {
        $$(`[data-opcao="${i}"]`).forEach(o =>
          o.setAttribute('aria-pressed', String(o.dataset.valor === valor)));
        const rotulo = $(`[data-opcao-escolhida="${i}"]`);
        if (rotulo) rotulo.textContent = valor;
      });
    }

    /* Só as miniaturas da cor escolhida. Foto sem cor marcada (produto de
       cor única, ou imagem solta) continua sempre visível. */
    function filtraMiniaturas() {
      const minis = $$('.galeria__mini');
      if (!minis.some(m => m.dataset.cor)) return;
      const cor = atual[0];
      minis.forEach(m => { m.hidden = !!m.dataset.cor && m.dataset.cor !== cor; });
    }

    function aplica() {
      const alvo = variantes.find(v => v.opcoes.every((x, i) => x === atual[i]));
      const botao = $('#form-compra [name="add"]');

      if (!alvo) {
        /* combinação que não existe no catálogo: não dá para comprar */
        if (botao) { botao.disabled = true; botao.textContent = 'Indisponível'; }
        return;
      }

      seletor.value = alvo.valor;
      seletor.dispatchEvent(new Event('change', { bubbles: true }));

      // o endereço acompanha a variante: link copiado abre o mesmo tamanho
      const url = new URL(window.location);
      url.searchParams.set('variant', alvo.valor);
      window.history.replaceState({}, '', url);

      filtraMiniaturas();

      /* Foto da cor. Só troca quando é outra foto — senão, mudar de tamanho
         jogaria o cliente de volta para a capa enquanto ele olha a sola. */
      if (alvo.fotoPos && alvo.fotoPos !== fotoAtual) {
        const mini = $$('.galeria__mini')[alvo.fotoPos - 1];
        if (mini) mini.click();
        fotoAtual = alvo.fotoPos;
      }

      /* o SKU muda com a cor: sem isto a página mostra o código da cor
         anterior, que é o número que o cliente usa para conferir a caixa */
      const sku = $('[data-sku]');
      if (sku && alvo.el.dataset.sku) sku.textContent = alvo.el.dataset.sku;

      const preco = Number(alvo.el.dataset.preco);
      const precoDe = Number(alvo.el.dataset.precoDe || 0);
      const bloco = $('#bloco-preco');
      if (bloco) {
        const de = precoDe > preco
          ? `<span class="compra__de">${brl(precoDe)}</span>` : '';
        const selo = precoDe > preco
          ? `<span class="compra__economia">-${Math.round((1 - preco / precoDe) * 100)}%</span>` : '';
        bloco.innerHTML = `${de}<span class="compra__por">${brl(preco)}</span>${selo}`;
      }

      // Parcelamento por faixa de valor: variantes do mesmo produto podem cair
      // em faixas diferentes (um tenis de R$ 290 e outro de R$ 320), por isso
      // isso e recalculado a cada troca de variante, e nao fixado no Liquid.
      const parcelas = (cfg.corteParcelas > 0 && preco < cfg.corteParcelas)
        ? (cfg.parcelasPedidoPequeno || 0)
        : (cfg.parcelas || 0);
      const linhaParcela = $('.compra__parcela');
      if (linhaParcela) {
        linhaParcela.textContent = parcelas > 1
          ? `ou ${parcelas}x de ${brl(Math.floor(preco / parcelas))} sem juros no cartão`
          : '';
      }
      // A linha com juros so faz sentido quando oferece MAIS vezes que a sem juros.
      const linhaJuros = $('.compra__parcela-juros');
      if (linhaJuros) {
        const comJuros = cfg.parcelasComJuros || 0;
        linhaJuros.textContent = comJuros > parcelas
          ? `ou em até ${comJuros}x com juros`
          : '';
      }
      const linhaPix = $('.compra__pix');
      if (linhaPix && cfg.descontoPix > 0) {
        const pix = Math.floor(preco * (100 - cfg.descontoPix) / 100);
        linhaPix.textContent = `${brl(pix)} à vista no Pix (${cfg.descontoPix}% de desconto)`;
      }

      if (botao) {
        botao.disabled = !alvo.disponivel;
        botao.textContent = alvo.disponivel ? 'Comprar agora' : 'Esgotado';
      }

      const estoque = $('[data-estoque-texto]');
      if (estoque) {
        const n = Number(alvo.el.dataset.estoque);
        estoque.textContent = n > 0 ? `${n} em estoque` : '';
      }
    }

    $$('[data-opcao]').forEach(botao => {
      botao.addEventListener('click', () => {
        if (botao.disabled) return;
        const i = Number(botao.dataset.opcao);
        atual[i] = botao.dataset.valor;

        /* Trocar de cor pode invalidar o tamanho escolhido: nem toda cor tem
           a grade inteira. Nesse caso puxa o primeiro tamanho com estoque em
           vez de deixar o cliente num botão morto. */
        for (let k = i + 1; k < atual.length; k++) {
          const aindaServe = variantes.some(v =>
            v.disponivel && casaAnteriores(v, k) && v.opcoes[k] === atual[k]);
          if (!aindaServe) {
            const alternativa = variantes.find(v => v.disponivel && casaAnteriores(v, k));
            /* sem alternativa a cor inteira acabou: fica no tamanho atual, que
               aparece esgotado — melhor do que pular para um tamanho ao acaso */
            if (alternativa) atual[k] = alternativa.opcoes[k];
          }
        }

        marcaDisponiveis();
        marcaEscolhidos();
        aplica();
      });
    });

    /* Estado inicial. O Liquid já entrega os botões certos, mas esconder
       miniatura depende de JS — sem isso a página abre com o kit das duas
       cores misturado por um instante. */
    filtraMiniaturas();

    /* quantidade, travada entre 1 e o estoque */
    const campo = $('#qtd');
    if (campo) {
      const ajusta = d => {
        const alvo = [...seletor.options].find(o => o.value === seletor.value);
        const max = Number(alvo?.dataset.estoque) || 99;
        const n = Math.min(max > 0 ? max : 99, Math.max(1, (parseInt(campo.value, 10) || 1) + d));
        campo.value = n;
      };
      $('#menos')?.addEventListener('click', () => ajusta(-1));
      $('#mais')?.addEventListener('click', () => ajusta(1));
      campo.addEventListener('change', () => ajusta(0));
    }

    /* galeria */
    $$('.galeria__mini').forEach(b => {
      b.addEventListener('click', () => {
        const foto = $('#imagem-ativa');
        if (foto) { foto.src = b.dataset.foto; foto.removeAttribute('srcset'); }
        $$('.galeria__mini').forEach(o => o.setAttribute('aria-current', 'false'));
        b.setAttribute('aria-current', 'true');
      });
    });
  })();

  /* abas */
  $$('.aba').forEach(botao => {
    botao.addEventListener('click', () => {
      $$('.aba').forEach(b => {
        b.setAttribute('aria-selected', 'false');
        const painel = document.getElementById(b.getAttribute('aria-controls'));
        if (painel) painel.hidden = true;
      });
      botao.setAttribute('aria-selected', 'true');
      const painel = document.getElementById(botao.getAttribute('aria-controls'));
      if (painel) painel.hidden = false;
    });
  });

  /* ------------------------------------------------------------------- sacola */
  (function sacola() {
    const lista = $('#form-sacola');
    if (!lista) return;

    async function alterar(linha, quantidade) {
      lista.style.opacity = '.5';
      lista.style.pointerEvents = 'none';
      try {
        const r = await fetch(cfg.rotas.alterar, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: linha, quantity: quantidade })
        });
        if (!r.ok) throw new Error(r.statusText);
        // recarrega para o resumo, o frete grátis e o contador virem do servidor
        window.location.reload();
      } catch (e) {
        lista.style.opacity = '';
        lista.style.pointerEvents = '';
        const aviso = document.createElement('p');
        aviso.className = 'cupom__aviso cupom__aviso--erro';
        aviso.textContent = 'Não foi possível atualizar a sacola. Tente de novo.';
        lista.prepend(aviso);
      }
    }

    lista.addEventListener('click', e => {
      const b = e.target.closest('[data-acao]');
      if (!b) return;
      e.preventDefault();
      const linha = Number(b.dataset.linha);
      const item = b.closest('.item');
      const atual = Number($('.qtd-mini span', item)?.textContent || 1);

      if (b.dataset.acao === 'mais') alterar(linha, atual + 1);
      if (b.dataset.acao === 'menos' && atual > 1) alterar(linha, atual - 1);
      if (b.dataset.acao === 'remover') alterar(linha, 0);
    });
  })();
})();
